/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.ShortcutButtonBlock.ShortcutButtonBlock
 */
import React from "react";
import classnames from "classnames";
import * as styles from "./base.scss";
import { addStandardEvent } from "../../../TrackingInformation/CustomGa4EventService";
import { pushState } from "Shared/history";
const ShortcutButtonBlock = (props) => {
    var _a, _b;
    const model = props.model;
    const sendToDataLayerAndRedirect = (eventType, link) => {
        addStandardEvent("Kampanjpuffar", "Kampanjpuff", "Click", eventType);
        if (model.isExternalLink) {
            !!link && window.open(link, "_blank", "noopener,noreferrer");
        }
        else {
            !!link && pushState(link);
        }
    };
    return (React.createElement("button", { className: classnames(styles.shortcutButton), onClick: () => sendToDataLayerAndRedirect(model.text, model.link), tabIndex: props.tabIndex },
        !!model.text && (React.createElement("label", { className: classnames(styles.text, styles.bodyMedium, {
                [styles.image]: !!model.isImage,
            }) }, model.text)),
        React.createElement("div", { className: classnames(styles.imageContainer, {
                [styles.image]: !!model.isImage,
            }) },
            !!model.image && model.isImage && (React.createElement("div", { style: { backgroundImage: "url(" + model.image + ")" }, role: "img", "aria-label": (_a = model.imageAltText) !== null && _a !== void 0 ? _a : "" })),
            !!model.image && !model.isImage && (React.createElement("img", { className: classnames(styles.icon), src: model.image, alt: (_b = model.imageAltText) !== null && _b !== void 0 ? _b : "" })))));
};
export default ShortcutButtonBlock;
